import React from "react";
import { motion } from "framer-motion";
import Icon from "../../../components/AppIcon";
import FakeAppChrome from "../FakeAppChrome";

const HIGHLIGHTS = [
  { icon: "Library", label: "Modelos prontos" },
  { icon: "Sparkles", label: "Preenchimento com IA" },
  { icon: "FileText", label: "Geração de PDF" },
  { icon: "PenLine", label: "Assinatura digital" },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08, delayChildren: 0.12 },
  },
};

const item = {
  hidden: { opacity: 0, y: 12 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
  },
};

const WelcomeScene = () => (
  <FakeAppChrome activeNavId="home">
    <div className="flex h-full min-h-[320px] items-center justify-center p-6 sm:p-10">
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="w-full max-w-xl rounded-xl border border-border bg-card p-6 sm:p-8 shadow-elevation-sm"
      >
        <motion.p
          variants={item}
          className="text-xs font-medium uppercase tracking-wide text-primary"
        >
          Demonstração guiada
        </motion.p>
        <motion.h3
          variants={item}
          className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight text-foreground"
        >
          neo-modelos
        </motion.h3>
        <motion.p
          variants={item}
          className="mt-3 text-sm sm:text-base text-muted-foreground leading-relaxed"
        >
          Veja como o sistema ajuda a criar, gerar e assinar documentos — sem
          precisar se cadastrar ainda.
        </motion.p>
        <motion.ul
          variants={container}
          className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3"
        >
          {HIGHLIGHTS.map((highlight) => (
            <motion.li
              key={highlight.label}
              variants={item}
              className="flex items-center gap-2.5 rounded-lg border border-border/80 bg-muted/30 px-3 py-2.5"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10 shrink-0">
                <Icon name={highlight.icon} size={16} className="text-primary" />
              </span>
              <span className="text-sm font-medium text-foreground">
                {highlight.label}
              </span>
            </motion.li>
          ))}
        </motion.ul>
      </motion.div>
    </div>
  </FakeAppChrome>
);

export default WelcomeScene;
